module.exports = __webpack_public_path__ + "static/ARB_PHOTOGRAPHY_4-cd6dd65a06e942c38d2daddf3f7c568e.jpg";